const stages = [
  {
    title: 'Этап 1. Определение задачи',
    desc: 'Понимаем, зачем сотруднику необходимо развитие.',
  },
  {
    title: 'Этап 2. Оценка текущего уровня',
    desc: 'Используем результаты оценки компетенций, интервью, обратную связь, наблюдение и рабочие показатели — в зависимости от задачи.',
  },
  {
    title: 'Этап 3. Определение дефицита',
    desc: 'Определяем разницу между текущим и необходимым уровнем.',
  },
  {
    title: 'Этап 4. Постановка цели',
    desc: 'Формулируем конкретный результат развития.',
  },
  {
    title: 'Этап 5. Выбор инструментов',
    desc: 'Определяем, что поможет сотруднику достичь цели: обучение, практика, наставничество, развивающие задачи, коучинг, участие в проектах, самостоятельная работа.',
  },
  {
    title: 'Этап 6. Определение сроков',
    desc: 'Формируем реалистичный период развития.',
  },
  {
    title: 'Этап 7. Определение критериев результата',
    desc: 'Фиксируем, как будет оцениваться изменение.',
  },
  {
    title: 'Этап 8. Сопровождение',
    desc: 'Руководитель или другой ответственный помогает сотруднику проходить план и корректирует его при необходимости.',
  },
  {
    title: 'Этап 9. Повторная оценка',
    desc: 'Проверяем, изменился ли уровень компетенций.',
  },
];

export default function HowIPRFormed() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как формируется индивидуальный план развития
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Последовательность шагов — от понимания задачи до проверки результата
        </p>

        <div className="space-y-4">
          {stages.map((s, i) => (
            <div key={i} className="flex items-start gap-4 bg-white rounded-xl border border-gray-200 p-5 hover:border-teal-200 transition-colors">
              <div className="w-10 h-10 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                {i + 1}
              </div>
              <div>
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1">{s.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}